import { notificationQueryOptions } from "@istari-frontend/notifications/data-source";
import { useQuery } from "@tanstack/react-query";

/**
 * Whether the registry serves an inbox, read from the unread-count query so it costs no extra request.
 * `hasInbox` is `undefined` until the first answer; a later failure keeps the last answer rather than dropping it.
 * A failed check is retried every 30 seconds; a 404 is an answer and is not retried.
 */
export function useInboxAvailability() {
  const query = useQuery({
    ...notificationQueryOptions.unreadCount(),
    select: (data) => data !== null,
    refetchInterval: (query) => (query.state.status === "error" ? INBOX_AVAILABILITY_RETRY_INTERVAL_MS : false),
  });
  return { hasInbox: query.data, isLoading: query.isLoading, isError: query.isError };
}

const INBOX_AVAILABILITY_RETRY_INTERVAL_MS = 30_000;
